import React from 'react';
import type { TablePaginationConfig, TableProps } from 'antd';
import {
  IProductAllocation,
  IProductAllocationReq,
  IProductAllocationRes,
} from '@/interfaces/product';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import TableComponent from '@/components/table';
import { IBusinessUnit } from '@/interfaces/business-unit';
import { formatNumber } from '@/utils/dataUtils';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';

interface IProps {
  loading: boolean;
  criteria: IProductAllocationReq;
  product: IProductAllocationRes;
  bus: IBusinessUnit[];
  onDelete?: (id: number) => void;
  onEditData?: (item: IProductAllocation) => void;
  onTableChange?: (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter:
      | SorterResult<IProductAllocation>
      | SorterResult<IProductAllocation>[],
  ) => void;
}

const ProductAllocationTable = ({
  loading,
  criteria,
  product,
  bus,
}: IProps) => {
  const columns: TableProps<IProductAllocation>['columns'] = [
    {
      title: 'รหัส',
      dataIndex: 'ProductCode',
      key: 'ProductCode',
      className: 'font-bold',
      width: 130,
      align: 'center',
    },
    {
      title: 'สินค้า',
      dataIndex: 'ProductName',
      key: 'ProductName',
      className: 'font-bold',
    },
    {
      title: 'สถานะ',
      dataIndex: 'IsActive',
      key: 'IsActive',
      width: 100,
      align: 'center',
      render: (_: boolean) => {
        return _ ? (
          <CheckCircleFilled className="text-green-600" />
        ) : (
          <CloseCircleFilled className="text-red-600" />
        );
      },
    },
    {
      title: 'Stock',
      dataIndex: 'TotalStock',
      key: 'TotalStock',
      width: 100,
      align: 'right',
      render: _ => <div>{(_ && formatNumber(Number(_ || 0))) || ''}</div>,
    },
  ];

  bus?.map(c => {
    columns.push({
      title: `${c.name}`,
      dataIndex: `${c.name}`,
      key: `${c.name}`,
      className: 'font-bold',
      width: 130,
      align: 'center',
      render: _ => <div>{(_ && formatNumber(Number(_ || 0))) || ''}</div>,
    });
  });

  return (
    <div className="flex flex-col gap-3">
      <TableComponent<IProductAllocation>
        columns={columns}
        criteria={criteria}
        data={product}
        loading={loading}
        showPagination={false}
        rowKey="ProductCode"
        // onTableChange={onTableChange}
      />
    </div>
  );
};

export default ProductAllocationTable;
